import React, { useEffect, useState } from 'react';

const IconCalendar = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const IconChat = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

const IconUsers = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const steps = [
  {
    icon: <IconChat />,
    title: 'Откройте бота в группе',
    desc: 'Нажмите /start в личке с ботом или напишите @имя_бота в чате группы',
  },
  {
    icon: <IconCalendar />,
    title: 'Создайте событие',
    desc: 'Заполните форму, делегируйте контроль посещаемости другим',
  },
  {
    icon: <IconUsers />,
    title: 'Управляйте записью',
    desc: 'Отмечайте посещаемость, управляйте списком участников',
  },
];

const HomePage = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f8fafc',
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: 40,
    }}>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50%       { transform: scale(1.06); }
        }
        .step-card {
          transition: box-shadow 0.2s, transform 0.2s;
        }
        .step-card:active {
          transform: scale(0.98);
        }
      `}</style>

      {/* ── Hero ── */}
      <div style={{
        background: 'linear-gradient(145deg, #6366f1 0%, #4f46e5 60%, #4338ca 100%)',
        padding: '52px 24px 48px',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Decorative circles */}
        <div style={{
          position: 'absolute', top: -40, right: -40,
          width: 160, height: 160, borderRadius: '50%',
          background: 'rgba(255,255,255,0.07)',
        }}/>
        <div style={{
          position: 'absolute', bottom: -20, left: -30,
          width: 100, height: 100, borderRadius: '50%',
          background: 'rgba(255,255,255,0.05)',
        }}/>

        <div style={{
          opacity: visible ? 1 : 0,
          animation: visible ? 'fadeUp 0.5s ease both' : 'none',
        }}>
          {/* Icon */}
          <div style={{
            width: 68, height: 68, borderRadius: 20,
            background: 'rgba(255,255,255,0.15)',
            backdropFilter: 'blur(8px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 20,
            animation: 'pulse 3s ease-in-out infinite',
          }}>
            <IconCalendar />
          </div>

          <h1 style={{
            margin: '0 0 10px',
            fontSize: 26, fontWeight: 800,
            letterSpacing: -0.5, lineHeight: 1.2,
          }}>
            EventDesk
          </h1>
          <p style={{
            margin: 0,
            fontSize: 15, opacity: 0.85, lineHeight: 1.6,
            maxWidth: 280,
          }}>
            Управление событиями и записью участников прямо в Telegram
          </p>
        </div>
      </div>

      {/* ── Content ── */}
      <div style={{ padding: '28px 16px 0', flex: 1 }}>



        {/* Steps */}
        <div style={{
          fontSize: 12, fontWeight: 700, color: '#9ca3af',
          textTransform: 'uppercase', letterSpacing: 0.6,
          marginBottom: 12,
          opacity: visible ? 1 : 0,
          animation: visible ? 'fadeUp 0.5s 0.15s ease both' : 'none',
        }}>
          Как это работает
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {steps.map((step, i) => (
            <div
              key={i}
              className="step-card"
              style={{
                background: '#fff',
                borderRadius: 14,
                padding: '14px 16px',
                boxShadow: '0 1px 8px rgba(0,0,0,0.05)',
                display: 'flex', alignItems: 'flex-start', gap: 14,
                opacity: visible ? 1 : 0,
                animation: visible ? `fadeUp 0.5s ${0.2 + i * 0.08}s ease both` : 'none',
              }}
            >
              {/* Step number + icon */}
              <div style={{ position: 'relative', flexShrink: 0 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 12,
                  background: 'linear-gradient(135deg, #6366f1, #4f46e5)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff',
                }}>
                  {step.icon}
                </div>
                <div style={{
                  position: 'absolute', top: -6, right: -6,
                  width: 18, height: 18, borderRadius: '50%',
                  background: '#fff',
                  border: '2px solid #6366f1',
                  fontSize: 10, fontWeight: 800, color: '#6366f1',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  {i + 1}
                </div>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#111827', marginBottom: 3 }}>
                  {step.title}
                </div>
                <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.5 }}>
                  {step.desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── CTA Button ── */}
      <div style={{
        padding: '24px 16px 0',
        opacity: visible ? 1 : 0,
        animation: visible ? 'fadeUp 0.5s 0.55s ease both' : 'none',
      }}>
      </div>
    </div>
  );
};

export default HomePage;